export default __webpack_public_path__ + "static/media/microwave.2c0bf52b.svg";